import * as ActionTypes from 'state/types'
import * as Selectors from 'state/selectors'
import Routes from 'shared/utils/api/routes'

export const fetchActivities = () => ({
  type: ActionTypes.ACTIVITIES_PREPARE,
  payload: {
    url: Routes.ACTIVITIES_LIST_ROUTE,
    method: 'get',
    unique: true
  },
  meta: {
    finalActionType: ActionTypes.ACTIVITIES_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getActivitiesNextPage,
        deepLevel:['params'],
        key: 'page'
      },
      {
        selector: Selectors.getSelectedInteractionId,
        deepLevel:['params'],
        key: 'interactionId'
      }
    ],
    meta: {
      successActions: [
        {
          type: ActionTypes.PAUSES_REQUEST,
          provideResponse: false,
          provideParentPayload: false,
          payload: {
            url: Routes.PAUSES_LIST_ROUTE,
            method: 'get'
          },
          selectorsToPayload: [
            {
              selector: Selectors.getSelectedInteractionThreadIdsStringified,
              deepLevel:['params'],
              key: 'threads'
            },
            {
              selector: Selectors.getActiveAgentId,
              deepLevel:['params'],
              key: 'agentId'
            }
          ]
        },
        {
          type: ActionTypes.TRIGGER_EVENTS_REQUEST,
          payload: {
            url: Routes.TRIGGER_EVENT_FIND_ROUTE,
            method: 'post'
          },
          selectorsToPayload: [
            {
              selector: Selectors.getActiveAgentId,
              deepLevel:['data'],
              key: 'agentId'
            }
          ]
        }
      ]
    }
  }
})

export const fetchActivitiesAll = () => ({
  type: ActionTypes.ACTIVITIES_PREPARE,
  payload: {
    url: Routes.ACTIVITIES_LIST_ALL_ROUTE,
    method: 'get',
    unique: true
  },
  meta: {
    finalActionType: ActionTypes.ACTIVITIES_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getSelectedInteractionId,
        deepLevel:['params'],
        key: 'interactionId'
      }
    ],
    meta: {
      successActions: [
        {
          type: ActionTypes.PAUSES_REQUEST,
          provideResponse: false,
          provideParentPayload: false,
          payload: {
            url: Routes.PAUSES_LIST_ROUTE,
            method: 'get'
          },
          selectorsToPayload: [
            {
              selector: Selectors.getSelectedInteractionThreadIdsStringified,
              deepLevel:['params'],
              key: 'threads'
            },
            {
              selector: Selectors.getActiveAgentId,
              deepLevel:['params'],
              key: 'agentId'
            }
          ]
        },
        {
          type: ActionTypes.TRIGGER_EVENTS_REQUEST,
          payload: {
            url: Routes.TRIGGER_EVENT_FIND_ROUTE,
            method: 'post'
          },
          selectorsToPayload: [
            {
              selector: Selectors.getActiveAgentId,
              deepLevel:['data'],
              key: 'agentId'
            }
          ]
        },
        scrollToTop()
      ]
    }
  }
})

export const getActivitiesDates = () => ({
  type: ActionTypes.GET_ACTIVITIES_DATES_PREPARE,
  payload: {
    url: Routes.ACTIVITIES_DATES,
    method: 'get',
    unique: true
  },
  meta: {
    finalActionType: ActionTypes.GET_ACTIVITIES_DATES_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getCustomerId,
        deepLevel:['params'],
        key: 'customerId'
      },
      {
        selector: Selectors.getSelectedInteractionId,
        deepLevel:['params'],
        key: 'interactionId'
      }
    ]
  }
})


export const activitiesBottomReached = () => ({
  type: ActionTypes.ACTIVITIES_BOTTOM_REACHED
})

export const scrollToTop = () => ({
  type: ActionTypes.SCROLL_TO_TOP
})

export const scrollToBottom = () => ({
  type: ActionTypes.SCROLL_TO_BOTTOM
})

export const finishScrollToTop = () => ({
  type: ActionTypes.FINISH_SCROLL_TO_TOP
})

export const finishScrollToBottom = () => ({
  type: ActionTypes.FINISH_SCROLL_TO_BOTTOM
})
